module.exports = __webpack_public_path__ + "img/effects_bubble_mood.9e50f3a8.png";